import React from 'react';

import Button from 'components/Button';

import './styles.css';

const Buttons = ({submitting, triggerSubmit, closeModal}) => {
  return (
    <div className="Buttons colab-row-space-between">
      <Button white className="cancel" onClick={closeModal}>
        Cancel
      </Button>
      <Button
        className="create"
        disabled={submitting}
        blue={!submitting}
        isLoading={submitting}
        onClick={triggerSubmit}>
        Create
      </Button>
    </div>
  );
};

export default Buttons;
